export const FETCH_CREDIT_START = 'FETCH_CREDIT_START';
export const FETCH_CREDIT_SUCCESS = 'FETCH_CREDIT_SUCCESS';
export const FETCH_CREDIT_FAIL = 'FETCH_CREDIT_FAIL';
